<template>
  <van-popup position="bottom" v-model="isShow">
    <div class="container f28">
      <div class="title">选择优惠券</div>
      <ul>
        <li v-for="(item, index) in couponList" :key="index"
            :style="{'backgroundImage':'url(/images/my/' + getItem(item).backgroundImg+'.png)'}">
          <div class="inner">
            <h3 v-html="getItem(item).title"></h3>
            <h4 class="f24">1808无Logo猜包答对四道题96折</h4>
            <h5 class="f20 grey6">满180元可使用，适用包包数量1个</h5>
            <time class="f20 grey9">2019.01.08（到包结束时间）</time>
          </div>
        </li>
      </ul>
      <div class="close" @click="hide"></div>
    </div>
  </van-popup>
</template>

<script>
  import { Popup } from 'vant'
  export default {
    name: 'selectService',
    components: {
      'van-popup': Popup
    },
    data () {
      return {
        isShow: false,
        couponList: [
          { useType: 0, orderCanUse: 0 },
          { useType: 1, orderCanUse: 0 },
          { useType: 2, orderCanUse: 0 },
          { useType: 0, orderCanUse: 1 },
          { useType: 1, orderCanUse: 1 },
          { useType: 2, orderCanUse: 1 }
        ]
      }
    },
    methods: {
      getItem (item) {
        let backgroundImg = '', title = ''
        switch (item.useType) {
          // 0:满减 1:打折 2:礼物
          case 0:
            backgroundImg = 'coupon_mask1'
            title = '88<span class="aa">元</span>'
            break
          case 1:
            backgroundImg = 'coupon_mask2'
            title = '8.8<span class="aa">折</span>'
            break
          case 2:
            backgroundImg = 'coupon_mask3'
            title = '赠品'
            break
        }
        // 0:不能使用 1:可以使用
        if (item.orderCanUse === 0) {
          backgroundImg += '.1'
        }
        return { backgroundImg: backgroundImg, title: title }
      },
      show () {
        this.isShow = true
      },
      hide () {
        this.isShow = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .van-popup--bottom{
    width: 101%;
  }
  .container{
    height: 1000px;
    padding: 30px;
    position: relative;
    .title{
      line-height: 40px;
      margin-bottom: 50px;
    }
    ul{
      position: absolute;
      top: 100px;
      left: 0;
      bottom: 0;
      overflow-y: scroll;
      width: 100%;
      li{
        height: 200px;
        padding: 20px;
        margin-bottom: -20px;
        /*border-radius:100px;*/
        background: no-repeat left top;
        background-size: 100%;
        .inner{
          width: 420px;
          padding: 6px 40px 0;
        }
        h3{
          font-size: 60px;font-weight: bold;
          line-height: 84px;
        }
        h4{line-height: 34px}
        h5,time{line-height: 28px}
      }
    }
    .bottom{
      position: absolute;
      width: 690px;
      bottom: 30px;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      .submit{
        margin-left: 20px;
      }
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
  }
</style>
